export const state = {
  searchKey: ''
};
